<template>
  <!-- TODO: Use new table attributes for responsive and sticky when they're out -->
  <BTable
    class="clickable-rows"
    :items="mappedCourses"
    :fields="dateFields"
    show-empty
    responsive
    sticky-header
    fixed
    @row-clicked="(event) => $emit('rowClicked', event)"
  >
    <!-- TODO: introduce loading state-->
    <template #table-busy>
      <div class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>

    <template #table-colgroup="scope">
      <col
        v-for="field in scope.fields"
        :key="field.key"
        :style="{
          width: colSizes[field.key],
          maxWidth: '200px',
        }"
      />
    </template>

    <template #cell(startDate)="data">
      <span>{{ formatDate(data.item.start_datetime) }}</span>
    </template>

    <template #cell(startTime)="data">
      <span>{{ formatTime(data.item.start_datetime) }}</span>
    </template>

    <template #cell(location)="data">
      <span class="location-cell">{{ data.item.location }}</span>
    </template>

    <template #cell(status)="data">
      <EventDateStatusChip :status="data.item.status" />
    </template>

    <template #cell(actions)="data">
      <BaseButtonIcon
        v-if="data.item.status !== 'CANCELLED' && hasCoursesWritePermission"
        outline
        :title="$t('product_events.CANCEL_DATE')"
        :aria-label="$t('product_events.CANCEL_DATE')"
        size="small"
        @click="
          (event) => {
            event.stopPropagation()
            emit('onClickCancelButton', data.item.id)
          }
        "
      >
        <CancelIcon />
      </BaseButtonIcon>
    </template>

    <!-- TODO: looks weird with white background that's included in image -->
    <template #empty>
      <div class="no-dates-container">
        <img class="image" :src="noDatesExistsImage" alt="" />
        <div class="no-dates-container__text">
          {{ $t('product_events.MESSAGE_NO_DATES_ADDED') }}
        </div>
      </div>
    </template>
  </BTable>

  <!--      TODO: This is not working in today's solution (only shown), we should implement pagination, and probably by intersection and infinite scroll -->
  <!--      <b-pagination-->
  <!--        v-if="isPagination"-->
  <!--        :value="pagination.current"-->
  <!--        :total-rows="pagination.count"-->
  <!--        :per-page="pagination.perPage"-->
  <!--        align="center"-->
  <!--        class="tab-table-pagination date-calendar-pagination"-->
  <!--        @change="updatePagination"-->
  <!--      />-->
</template>

<script setup lang="ts">
import { noDatesExistsIcon } from '@/assets/img/events/index.js'
import EventDateStatusChip from '@/components/product/product_components/component_events/date_info_components/EventDateStatusChip.vue'
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import { useI18n } from '@/hooks/useI18N.ts'
import { useUserPermission } from '@/hooks/usePermission.ts'
import moment from 'moment'
import { computed, ref } from 'vue'
import { useDateTimeFormat } from '@/hooks/useDateTimeFormat.ts'
import CancelIcon from '@/components/icon_components/CancelIcon.vue'

const i18n = useI18n()
const noDatesExistsImage = ref(noDatesExistsIcon)
const { formatTime, formatDate } = useDateTimeFormat()
const { canWrite: hasCoursesWritePermission } = useUserPermission('courses')

const emit = defineEmits(['rowClicked', 'onClickCancelButton'])

const props = withDefaults(
  defineProps<{
    items: any
  }>(),
  { items: [] }
)

const colSizes = {
  startDate: '145px',
  startTime: '100px',
  attendeesOfMax: '80px',
  location: 'auto',
  status: '150px',
  actions: '100px',
}

const dateFields = [
  {
    key: 'startDate',
    label: i18n.t('product_events.START'),
  },
  {
    key: 'startTime',
    label: i18n.t('product_events.TIME'),
  },
  {
    key: 'attendeesOfMax',
    label: i18n.t('product_events.ATTENDEES'),
    thClass: 'align-right',
    tdClass: 'align-right',
  },
  {
    key: 'location',
    label: i18n.t('product_events.ADDRESS'),
  },
  {
    key: 'status',
    label: i18n.t('STATUS'),
  },
  {
    key: 'actions',
    label: i18n.t('ACTIONS'),
    thClass: 'align-right',
    tdClass: 'align-right',
  },
]

const mappedCourses = computed(() =>
  props.items.map((date) => {
    const attendeesCountPadded = String(date.attendees_count).padStart(
      date.attendees_count_max.toString().length,
      '0'
    )

    const getStatus = () => {
      if (date.state === 'canceled') return 'CANCELLED'
      if (moment().isAfter(date.end_datetime)) return 'COMPLETED'
      return 'UPCOMING'
    }

    return {
      id: date.id,
      start_datetime: date.start_datetime,
      attendeesOfMax: `${attendeesCountPadded}/${date.attendees_count_max}`,
      status: getStatus(),
      location: date.location || i18n.t('product_events.NO_LOCATION'),
      attendees_count: date.attendees_count,
      originalDate: date,
    }
  })
)
</script>
<style lang="scss" scoped>
.location-cell {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 60px;
}

.button-add-date {
  display: flex;
  align-items: center;
}

.no-dates-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: $spacing-4xs;

  &__text {
    @include subtitle;
    color: $color-text-light;
    text-align: center;
    padding: 0 $spacing-xs;
  }
}
</style>
